// components/FieldTypeSpecificOptions.jsx
import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const FieldTypeSpecificOptions = ({
  classes,
  fieldType,
  selectedField,
  setSelectedField,
}) => {
  // Radio Options Component
  if (fieldType === "radio") {
    // Check if options exist and have the expected structure
    if (!selectedField?.options || selectedField.options.length === 0) {
      return (
        <Box className={classes.optionsSection}>
          <Typography variant="subtitle1" gutterBottom>
            Radio Options
          </Typography>
          <Typography variant="body2" color="textSecondary">
            No options available for this radio field.
          </Typography>
        </Box>
      );
    }

    return (
      <Box className={classes.optionsSection}>
        <Typography variant="subtitle1" gutterBottom>
          Radio Options
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ maxHeight: 300, marginBottom: 2 }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Caption</TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedField.options.map((option, index) => (
                <TableRow key={option.id || index}>
                  <TableCell>{option.caption}</TableCell>
                  <TableCell>{option.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ display: "block", marginTop: 1 }}
        >
          Default value:{" "}
          {selectedField.instructions?.includes("default")
            ? selectedField.instructions.match(
                /default its value should be "(.*?)"/i
              )?.[1] || "Not specified"
            : "Not specified"}
        </Typography>
      </Box>
    );
  }

  // Default Value Component for text-based fields
  if (
    [
      "string",
      "number",
      "date",
      "people",
      "location",
      "telephone",
      "clause",
      "multiline"
    ].includes(fieldType)
  ) {
    return (
      <TextField
        label="Default Value"
        fullWidth
        margin="normal"
        multiline={fieldType === "clause"}
        rows={fieldType === "clause" ? 4 : 1}
        value={selectedField.default_value || ""}
        onChange={(e) =>
          setSelectedField({
            ...selectedField,
            default_value: e.target.value,
          })
        }
      />
    );
  }

  // For checkbox fields
  if (fieldType === "checkbox-list") {
    return (
      <Box className={classes.checkboxOptions}>
        <Typography variant="subtitle1" gutterBottom>
          Checkbox Options
        </Typography>
        <TextField
          label="Default Value (checked/unchecked)"
          select
          fullWidth
          margin="normal"
          value={selectedField.checked ? "checked" : "unchecked"}
          onChange={(e) =>
            setSelectedField({
              ...selectedField,
              checked: e.target.value === "checked",
            })
          }
        >
          <option value="checked">Checked</option>
          <option value="unchecked">Unchecked</option>
        </TextField>
      </Box>
    );
  }

  // Specialized options for signature fields
  if (fieldType === "signature") {
    return (
      <Box className={classes.signatureOptions}>
        <Typography variant="subtitle1" gutterBottom>
          Signature Options
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Signature fields allow users to draw or upload a signature.
        </Typography>
      </Box>
    );
  }

  // If no specific options are needed
  return null;
};

export default FieldTypeSpecificOptions;
